// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Top100LabelsForm_form_104x4{gap:24px}.Top100LabelsForm_form_104x4,.Top100LabelsForm_labelsInput_23OUt{display:flex;flex-direction:column}.Top100LabelsForm_labelsInput_23OUt{gap:16px}.Top100LabelsForm_labelInput_1MwQb{display:flex;align-items:center;gap:16px}.Top100LabelsForm_removeIcon_2UPLE{color:#8391a2;flex-shrink:0}.Top100LabelsForm_removeIcon_2UPLE:hover{color:#f5abab}.Top100LabelsForm_addLabelBtn_3f_rF{align-self:flex-start;display:flex;align-items:center;gap:8px}.Top100LabelsForm_addIcon_2uak1{width:16px;height:16px}.Top100LabelsForm_error_1_1cy{color:#f5abab;font-size:14px;padding:16px;background:rgba(245,171,171,.1);border-radius:10px;border:1px solid rgba(245,171,171,.2)}", ""]);
// Exports
exports.locals = {
	"form": "Top100LabelsForm_form_104x4",
	"labelsInput": "Top100LabelsForm_labelsInput_23OUt",
	"labelInput": "Top100LabelsForm_labelInput_1MwQb",
	"removeIcon": "Top100LabelsForm_removeIcon_2UPLE",
	"addLabelBtn": "Top100LabelsForm_addLabelBtn_3f_rF",
	"addIcon": "Top100LabelsForm_addIcon_2uak1",
	"error": "Top100LabelsForm_error_1_1cy"
};
module.exports = exports;
